import { createContext } from 'react';

var UserContext = /*#__PURE__*/ createContext({});

export { UserContext as default };
